import TileFrame from './TileFrame.jsx';
import { ScopeProvider } from '../lib/ScopeContext.jsx';
import Icon from './Icon.jsx';

// The charts the Owl picked to show its briefing's points (server/briefingVisuals.js)
// — they ride on the briefing payload as `brief.visuals`. Each is a REAL tile from
// the client's own dashboards, run with the filters its dashboard applies —
// exactly like a home pin — so scope, event locks and the white-label chart
// palette are the existing ones. Mobile-first: one per row on a phone, two-up from
// tablet width. Nothing renders when there are none, so a briefing without
// visuals is unchanged.
export default function BriefingVisuals({ visuals, isMobile, entityId, onOpen }) {
  const shown = (visuals || []).filter((v) => v && v.tile);
  if (!shown.length) return null;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: isMobile || shown.length === 1 ? '1fr' : 'repeat(2, minmax(0, 1fr))', gap: 12, marginTop: 14 }}>
      {shown.map((v) => (
        <div key={v.id} style={{ minWidth: 0, border: '1px solid var(--hairline)', borderRadius: 12, background: 'var(--card)', overflow: 'hidden' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '4px 6px 0 10px' }}>
            <span aria-hidden style={{ display: 'inline-flex', color: 'var(--muted)' }}><Icon name={v.icon || 'pin'} size={14} /></span>
            <span style={{ flex: 1, minWidth: 0, fontSize: 10.5, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em', color: 'var(--muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {v.caption || v.label}{v.suiteName ? ` · ${v.suiteName}` : ''}
            </span>
            {onOpen && (
              <button onClick={() => onOpen(v.suiteId, v.dashboardId)} title={`Open ${v.dashTitle || 'the dashboard'}`} style={openBtn}>↗</button>
            )}
          </div>
          <div style={{ height: isMobile ? 220 : 240 }}>
            <ScopeProvider suiteId={v.suiteId} suiteName={v.setName || ''} entityId={entityId} dashboardId={v.dashboardId} dashboardContext="">
              <TileFrame tile={v.tile} filterValues={v.filterValues || {}} editable={false} />
            </ScopeProvider>
          </div>
        </div>
      ))}
    </div>
  );
}

const openBtn = { flexShrink: 0, border: 'none', background: 'rgba(128,128,128,0.12)', color: 'var(--muted-2)', borderRadius: 980, minWidth: 40, height: 40, fontSize: 13, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1 };
